import { useEffect, useRef } from "react";

/**
 * ビューポート内に要素が表示されたかどうかを検知するフック
 * @example
 * // 一覧の最後にスクロールしたら新しいアイテムを読み込む例
 * function List() {
 *   const sentinel = useIntersectionObserver(() => {
 *     loadMoreItems();
 *   });
 *
 *   return (
 *     <div>
 *       {items.map((item, index) => (
 *         <div key={index}>{item}</div>
 *       ))}
 *       <div ref={sentinel} role="presentation" aria-hidden="true" />
 *     </div>
 *   );
 * }
 */
export function useIntersectionObserver(
  onIntersect: () => void,
  options?: IntersectionObserverInit,
) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        onIntersect();
      }
    }, options);

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [onIntersect, options]);

  return ref;
}
